/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";
import ClientProfile from "@shared/Profile/ClientProfile";
import {ProgramCategoryEnum} from "@shared/Program/CoachingProgram";

export default class ProgramInvite extends DbBaseObject{

	coachId: string = ""
	programId: string = ""
	isEnabled: boolean = true

	isMultipleInvite: boolean = false

	constructor() {
		super();
	}

	generateInviteLink(clientId) {
		let domain = process.env.VUE_APP_DOMAIN || "https://qwoach.com"
		let inviteId = this.id || "";
		let coachId = this.coachId || "";
		let inviteLink =  domain + "/app/accept-invite/" + coachId + "?code=" + inviteId;
		if(clientId){
			inviteLink += "&cid=" + clientId
		}
		return inviteLink
	}

	createClientProfile(userId){
		let clientProfile = new ClientProfile()
		clientProfile.name = this.clientName
		clientProfile.email = this.clientEmail
		clientProfile.coachId = this.coachId
		clientProfile.clientId = userId || null
		clientProfile.currentProgramId = this.programId
		clientProfile.addProgramId(this.programId)
		return clientProfile
	}

	setId(id){
		if(id){
			this.id = id
			this.generateInviteLink()
		}
	}

	canDeleteAfterAccept(){
		return !this.isMultipleInvite && !this.isTemplate()
	}

	isTemplate(){
		return this.category === ProgramCategoryEnum.TEMPLATE
	}

}
